// Radar-owned presentation for the existing Decisions register.
//
// The register itself remains the source of truth for data, filters, status
// vocabulary, and role-gated CRUD. This wrapper only gives the unchanged
// register a governed panel shell beneath Radar's feed.

import React from "react";
import { T } from "../../app/tokens.js";
import { DecisionsRegisterPage } from "../leases/DecisionsRegisterPage.jsx";

export function RadarDecisionsPanel({ currentRole, focused = false }) {
  return (
    <section
      data-testid="radar-decisions-panel"
      aria-labelledby="radar-decisions-heading"
      style={{
        marginTop: focused ? 0 : 28,
        padding: focused ? 0 : "20px 20px 4px",
        border: focused ? "none" : "1px solid var(--v2-line)",
        borderRadius: focused ? 0 : 14,
        background: focused ? "transparent" : "var(--v2-card)",
        boxShadow: focused ? "none" : "var(--v2-shadow-card)",
      }}
    >
      <div
        id="radar-decisions-heading"
        style={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
          gap: 12,
          marginBottom: 4,
        }}
      >
        <div>
          <h2 style={{
            margin: 0,
            fontSize: T.fsLgX2,
            fontWeight: T.fwBold,
            color: "var(--v2-dark)",
          }}>
            Decisions
          </h2>
          <div style={{ marginTop: 3, color: "var(--v2-mid)", fontSize: T.fsBase }}>
            Logged intent and active decision-making across the portfolio.
          </div>
        </div>
      </div>
      <DecisionsRegisterPage currentRole={currentRole} embedded />
    </section>
  );
}